<template>
  <div class="side-menu-wrapper" :class="{ 'is-collapsed': isCollapse }">
    <el-scrollbar class="side-menu-scroll">
      <el-select
        class="lySelect"
        v-model="activeSiteId"
        size="small"
        style="width: 188px"
        v-if="!isCollapse && isSingleSite && !userRole.includes('单站演示')"
        @change="handleActiveSiteChange"
      >
        <el-option v-for="item in siteList" :key="item.id" :label="item.item_label" :value="item.id" />
      </el-select>
      <CurrentTime v-show="isSingleSite"></CurrentTime>
      <el-menu
        ref="navbar"
        class="el-menu-vertical scroll_content"
        active-text-color="var(--menu-active-color)"
        text-color="#fff"
        router
        :default-active="activeMenu || props.defaultActive"
        collapse-transition
        :collapse="isCollapse"
        unique-opened
        @select="handleSelect"
      >
        <template v-for="(val, sq) in menuData.menuList.filter(i => !i.meta.hide)" :key="sq">
          <el-sub-menu v-if="val.children && val.children.filter(c => !c.meta.hide).length" :index="`${menuData.path}/${val.path}`" class="val1">
            <template #title>
              <i :class="val.meta.icon" class="icon iconfont" />
              <span> {{ specialTranslate(['systemMenu', 'menuListData'], val.meta._meauname) }}</span>
            </template>
            <el-menu-item v-for="(subValue, indexkey) in val.children" :index="`${menuData.path}/${val.path}/${subValue.path}`" :key="indexkey">
              <i :class="subValue.meta.icon" class="icon iconfont" />
              <template #title>{{ specialTranslate(['systemMenu', 'menuListData'], subValue.meta._meauname) }}</template>
            </el-menu-item>
          </el-sub-menu>
          <el-menu-item v-else class="Secondary" :index="getMenuIndex(val)">
            <i :class="val.meta.icon" class="icon iconfont" />
            <template #title>{{ specialTranslate(['systemMenu', 'menuListData'], val.meta._meauname) }}</template>
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
    <div
      v-if="!userRole.includes('聚合')"
      class="iconfont menu-collapse-toggle upmenu"
      :class="[isCollapse ? 'icon-shouqi' : 'icon-zhankai']"
      @click="handleToggle"
    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted, reactive, computed } from 'vue'
import CurrentTime from './currentTime.vue'
import { useStore } from 'vuex'
import { getSites } from '@/server/site'
import useStorage from '@/hooks/storage'
import { specialTranslate } from '@/language/hooks.js'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()
const { getStorage, setStorage, removeStorage } = useStorage()
const emits = defineEmits(['select', 'changeSite', 'toggle'])
const store = useStore()
// 默认打开
const handleSelect = index => {
  emits('select', index)
}
const handleToggle = () => {
  emits('toggle')
}
const props = defineProps({
  isCollapse: {
    type: Boolean,
  },
  dataList: {
    type: Object,
    default: () => {},
  },
  defaultActive: {
    type: String,
    default: '',
  },
})
const menuData = reactive({
  path: '/',
  menuList: [],
})
const activeMenu = ref()
const navbar = ref()
const getMenuIndex = item => {
  return `${menuData.path}/${item.path}`
}
const getMenuBtnList = (menuTreeList, List) => {
  // 数据清洗
  menuTreeList.forEach((element, index) => {
    if (element.children) {
      List.push({
        label: element.label,
        icon: `iconfont ${element.icon}`,
        path: element.path, // 暂定
        children: [],
      })
      getMenuBtnList(element.children, List[index].children)
    } else {
      List.push({
        label: element.label,
        icon: `iconfont ${element.icon}`,
        path: element.path, // 暂定
      })
    }
  })
}

const getActiveIndexByRoutePath = path => {
  if (!path) return props.defaultActive

  const candidates = []
  const base = menuData.path || ''

  menuData.menuList.forEach(val => {
    if (!val) return

    // 子项中至少有一个不隐藏时，渲染为 el-sub-menu
    if (val.children && val.children.filter(c => !c.meta?.hide).length) {
      candidates.push(`${base}/${val.path}`)
      val.children.forEach(subValue => {
        if (!subValue?.path) return
        candidates.push(`${base}/${val.path}/${subValue.path}`)
      })
    } else {
      // 子项全隐藏时，渲染为单独的 el-menu-item（例如电池检测）
      candidates.push(getMenuIndex(val))
    }
  })

  // 1) 精确匹配优先
  const exact = candidates.find(i => i && i === path)
  if (exact) return exact

  // 2) 否则取“最长前缀”
  let best = ''
  candidates.forEach(i => {
    if (!i) return
    if (path === i || path.startsWith(`${i}/`)) {
      if (i.length > best.length) best = i
    }
  })
  return best || props.defaultActive
}

const syncActiveMenuByRoute = () => {
  activeMenu.value = getActiveIndexByRoutePath(route.path)
}

const userRole = computed(() => store.getters.getUserRole)
watch(
  () => props.dataList.data,
  () => {
    menuData.menuList = []
    menuData.path = props.dataList.path
    menuData.menuList = props.dataList.data
    // getMenuBtnList(props.dataList.data, menuData.menuList)
    syncActiveMenuByRoute()
  },
)

// 监听如果是单站监控的话展示选择站点
const isSingleSite = ref(false)
watch(
  () => menuData.path,
  async () => {
    await setActiveSite()
    if (['/SingleStationMonitor', '/development'].includes(menuData.path)) {
      isSingleSite.value = true
    } else {
      isSingleSite.value = false
    }

    // 切换一级路由范围后，同步高亮
    syncActiveMenuByRoute()
  },
)

const activeSiteId = ref()
const siteList = ref([])
// 设置选中站点
const setActiveSite = async () => {
  try {
    let userInfo = getStorage('userInfo')
    userInfo = userInfo.user_info
    const res = await getSites({
      include_hide: 0,
      userid: userInfo.user_id,
      roleids: userInfo.roleids,
    })
    if (res.data && res.data.msg) {
      siteList.value = res.data.msg
      let activeId = getStorage('activeSiteId')
      if (activeId) {
        const findOne = siteList.value.find(item => item.id === activeId)
        if (!findOne) {
          activeId = siteList.value[0].id
          store.dispatch('setSiteInformation', siteList.value[0]) //储存站点信息
        } else {
          store.dispatch('setSiteInformation', findOne) //储存站点信息
        }
      } else {
        activeId = siteList.value[0].id
        store.dispatch('setSiteInformation', siteList.value[0]) //储存站点信息
      }
      changeSite(activeId)
      activeSiteId.value = activeId
      store.dispatch('setActiveSiteId', activeId)
      setStorage('activeSiteId', activeId)
    }
  } catch (error) {
    console.log(error)
  }
}

// 获取选中站点数据，传给父组件改变logo/title
const changeSite = id => {
  // 在siteList.value中找到id匹配的item
  const findOne = siteList.value.find(item => item.id === id)

  emits('changeSite', JSON.parse(findOne.item_extra_content)?.system_config)
}

watch(
  () => store.getters.getSiteInformation,
  val => {
    if (!val.item_extra_content) return
    // // console.log(JSON.parse(val.item_extra_content).routeMapping_rows)
    if (val.item_extra_content && JSON.parse(val.item_extra_content).routeMapping_rows) {
      const routeMapping_rows = JSON.parse(val.item_extra_content).routeMapping_rows
      for (let key in routeMapping_rows) {
        if (routeMapping_rows[key].rename) {
          let keys = key.split('/')
          let pathKey = keys[keys.length - 1]

          let findOne = null
          for (let i = 0; i < menuData.menuList.length; i++) {
            if (findOne) break
            let item = menuData.menuList[i]
            if (item.path === pathKey) {
              findOne = item
              break
            }
            if (item.children) {
              for (let j = 0; j < item.children.length; j++) {
                if (item.children[j].path === pathKey) {
                  findOne = item.children[j]
                  break
                }
              }
            }
          }
          if (findOne) {
            findOne.meta._meauname = routeMapping_rows[key].rename
          }
        }
      }
    }
  },
  { immediate: true },
)

watch(
  () => router.currentRoute.value.query.goSiteId,
  async val => {
    if (router.currentRoute.value.path === '/SingleStationMonitor/HomepageCover' && val) {
      const query = router.currentRoute.value.query
      if (query.title && query.icon) {
        sessionStorage.setItem('singleSitePageSettings', JSON.stringify({ page_title: query.title, page_icon: query.icon }))
      }
      setStorage('activeSiteId', val)
    }
  },
  { immediate: true },
)

// 选中站点变化
function handleActiveSiteChange(val) {
  removeStorage('timeBucket', 'session')
  changeSite(val)
  store.dispatch('setActiveSiteId', activeSiteId.value)
  store.dispatch(
    'setSiteInformation',
    siteList.value.find(item => item.id === activeSiteId.value),
  ) //储存站点信息
  setStorage('activeSiteId', activeSiteId.value)
}

onMounted(() => {
  menuData.path = props.dataList.path
  menuData.menuList = props.dataList.data
  // getMenuBtnList(props.dataList.data, menuData.menuList)
  syncActiveMenuByRoute()
})

watch(
  () => route.path,
  () => {
    syncActiveMenuByRoute()
  },
)
</script>

<style lang="scss" scoped>
.side-menu-wrapper {
  position: relative;
  height: 100%;
  background: var(--ui-aside-bg, var(--header-background-color, transparent));
}

.side-menu-scroll {
  height: 100%;
  text-align: center;

  :deep(.el-scrollbar__view) {
    padding-bottom: 56px;
  }
}

.menu-collapse-toggle {
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 10;
  cursor: pointer;
  font-size: 16px;
  color: #fbffff;
  text-align: center;
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.side-menu-wrapper.is-collapsed .menu-collapse-toggle {
  right: 8px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 210px;
}
.icon {
  padding-right: 10px;
}
.el-menu {
  --el-menu-bg-color: transparent;
  --el-menu-hover-bg-color: transparent;
  background: transparent;

  .el-menu-item.is-active {
    background: var(--hover-imgurl);
    background-size: 100% 100%;
  }
  :deep(.el-sub-menu__title:hover) {
    background: none;
  }
}

.lySelect {
  margin-top: 12px;
  margin-bottom: 14px;

  :deep(.el-input__wrapper) {
    background: var(--ui-aside-bg, var(--switchSites, #101d35));
    box-shadow: 0 0 0 0 var(--line-color) inset;
    height: 42px;
    color: #fff;
    border-radius: 66px 66px 66px 66px;
    border: 1px solid var(--ui-panel-border-strong, rgba(185, 229, 253, 0.6));
  }
  :deep(.select-trigger) {
    background: var(--switchSites);
    border-radius: 50px;
    // box-shadow: 1px 1px 2px 0px rgb(241 230 230 / 23%);
    border: 1px solid var(--ui-panel-border-strong, rgba(185, 229, 253, 0.6));
  }
  :deep(.el-input__inner) {
    cursor: pointer;
    color: #fff;
    text-align: center;
    font-size: 16px;
  }
}
</style>
